import {
  UserRetailerCheckoutOrder,
  UserRetailerCheckoutOrderStatusV2,
} from "@/components/Checkout/types";
import ReduxStore from "@/redux/types";
import { useMatch } from "react-router-dom";

export const useLinkPrefix = () => {
  const match = useMatch({
    path: "/:page/b/:brandclubId",
    end: false,
    caseSensitive: false,
  });

  const linkPrefix = match?.pathname || "";
  return {
    linkPrefix,
  };
};

export const getPurchaseDetailLink = (
  routePrefix: string,
  appConfig: ReduxStore["appConfig"],
  order: UserRetailerCheckoutOrder
) => {
  const onDTC = appConfig?.domainConfig.storeBrandingType === "CustomDTCStore";

  const prefixUrlUrl = onDTC
    ? `/purchase`
    : routePrefix
    ? `${routePrefix}/branddashboard/purchase`
    : `/dashboard/purchase`;
  const status = order.status;
  if (status === UserRetailerCheckoutOrderStatusV2.checkout_in_progress) {
    return `/checkoutSummary?orderId=${order.orderId}`;
  }
  return `${prefixUrlUrl}/${order.orderId}`;
};
